import Swal from 'sweetalert2/dist/sweetalert2.esm.js';

$.rails.allowAction = (element) => {
  const message = element.data('confirm');
  const title = element.data('title') || I18n.t('extras.confirm_modal.default.title');
  const icon = element.data('type') || 'warning';
  const confirmButtonText = element.data('confirm-button-text') || I18n.t('extras.confirm_modal.default.yes_button_text');
  if (!message) {
    return true;
  }

  const url = element.attr('href');
  const method = element.data('method') || 'GET';
  Swal.fire({
    title,
    text: message,
    icon,
    showCancelButton: true,
    cancelButtonText: I18n.t('extras.confirm_modal.default.cancel_button_text'),
    confirmButtonText,
  }).then((result) => {
    if (!result.isConfirmed) {
      return;
    }

    const originalHtml = element.html();
    if (element.data('disable-with')) {
      element.text(element.data('disable-with'));
    }
    $.ajax({
      url,
      dataType: 'script',
      method: method.toUpperCase(),
    }).always(() => {
      element.html(originalHtml);
    });
  });
  return false;
};
